












































import { Component, Prop, Vue } from "vue-property-decorator";
import EntryList from "@/components/EntryList.vue";
import { Company, Brand, Product } from "@/models";
import Entry from "@/models/Entry";

@Component({
  components: {
    EntryList,
  },
})
export default class EntryListGroup extends Vue {
  @Prop() items!: {
    companies?: Company[];
    brands?: Brand[];
    products?: Product[];
  };

  @Prop() readonly canAdd?: (item: Entry) => boolean;
  @Prop({ default: false }) readonly selectable?: boolean;
  @Prop({ default: true }) readonly actions?: boolean;
  @Prop({ default: true }) readonly showTitles?: boolean;
  @Prop() readonly size?: string;

  onAdd(value: Company | Brand | Product) {
    this.$emit("add", value);
  }

  onRemove(value: Company | Brand | Product) {
    this.$emit("remove", value);
  }

  onSelected(value: Company | Brand | Product) {
    this.$emit("selected", value);
  }
}
